import {
  AnimateLayoutChanges,
  defaultAnimateLayoutChanges,
  useSortable,
  UseSortableArguments,
} from "@dnd-kit/sortable";
import { ReactNode } from "react";

type DraggableProps = UseSortableArguments & {
  children: (props: ReturnType<typeof useSortable>) => ReactNode;
};

const animateLayoutChanges: AnimateLayoutChanges = (args) =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true });

const Draggable = (props: Omit<DraggableProps, "disabled"> & { disabled?: boolean }) => {
  const rest = useSortable({
    id: props.id,
    disabled: {
      draggable: !!props.disabled,
      droppable: !!props.disabled,
    },
    animateLayoutChanges,
  });

  return props.children(rest);
};

export default Draggable;
